import { render, staticRenderFns } from "./manage-categories.modal.vue?vue&type=template&id=258471bc&scoped=true&"
import script from "./manage-categories.modal.vue?vue&type=script&lang=js&"
export * from "./manage-categories.modal.vue?vue&type=script&lang=js&"
import style0 from "./manage-categories.modal.vue?vue&type=style&index=0&id=258471bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258471bc",
  null
  
)

export default component.exports